<template>
  <div class="user-role" :class="{ expert }">
    <span>{{ role.title }}</span>
  </div>
</template>

<script>
export default {
  name: 'Role',
  props: {
    role: {
      default: () => ({}),
    },
  },
  computed: {
    expert() {
      return this.role.id > 1
    },
  },
}
</script>

<style lang="scss">
.user-role {
  color: $primary;
  display: inline-flex;
  align-items: center;
  font-weight: 700;
  font-size: 12px;
  line-height: 147.5%;
}
</style>
